import {setCookie} from '/src/js/custom/cookies';

let jsBrochure = document.querySelectorAll('.js-brochure');

jsBrochure.forEach(function (el) {
    el.addEventListener('click', function () {
        setCookie(el.dataset.cname, el.dataset.download, 1);
    });
});


